module.exports = __webpack_public_path__ + "044bab7e91b0fe2010cef20dccd0a676.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-13.png
// module id = 3240
// module chunks = 0